import { AxiosClient, apiConfig, BASE_URL } from "./AxiosClient";

export const getHomeViews = () => {
  try {
    return AxiosClient.get("home/getHomeViews");
  } catch (e) {
    console.log(e);
  }
};

export const createHomeView = (payload) => {
  try {
    return AxiosClient.post("home/createHomeView", payload);
  } catch (e) {
    console.log(e);
  }
};

export const updateHomeView = (payload) => {
  try {
    return AxiosClient.post("home/updateHomeView", payload);
  } catch (e) {
    console.log(e);
  }
};

export const deleteHomeView = (payload) => {
  try {
    return AxiosClient.post("home/deleteHomeView", payload);
  } catch (e) {
    console.log(e);
  }
};

export const resetHomeView = (payload) => {
  try {
    return AxiosClient.post("home/resetHomeView", payload);
  } catch (e) {
    console.log(e);
  }
};

export const getHomeLayout = (viewId) => {
  try {
    return AxiosClient.get("home/getHomeLayout?view_id=" + viewId);
  } catch (e) {
    console.log(e);
  }
};

export const saveHomeLayout = (payload) => {
  try {
    return AxiosClient.post("home/saveHomeLayout", payload);
  } catch (e) {
    console.log(e);
  }
};

export const saveHomeViewOrder = (payload) => {
  try {
    return AxiosClient.post("home/saveHomeViewOrder", payload);
  } catch (e) {
    console.log(e);
  }
};

// ── Widget Builder ──

export const getWidgetCollections = () => {
  try {
    return AxiosClient.get("home/widget-builder/collections");
  } catch (e) {
    console.log(e);
  }
};

export const getWidgetFields = (collection, sampleSize = 50) => {
  try {
    return AxiosClient.get(
      "home/widget-builder/fields/" +
        encodeURIComponent(collection) +
        "?sample_size=" +
        sampleSize,
    );
  } catch (e) {
    console.log(e);
  }
};

export const widgetBuilderPreview = (config) => {
  try {
    return AxiosClient.post("home/widget-builder/preview", config);
  } catch (e) {
    console.log(e);
  }
};

export const getWidgetDistinctValues = (collection, field) => {
  try {
    return AxiosClient.post("home/widget-builder/distinct", {
      collection,
      field,
    });
  } catch (e) {
    console.log(e);
  }
};

export const getDigest = (force = false) => {
  try {
    return AxiosClient.get("home/digest" + (force ? "?force=true" : ""), {
      responseType: force ? "text" : undefined,
      useTarget: true,
    });
  } catch (e) {
    console.log(e);
  }
};

export const getDigestStream = (force = false) => {
  try {
    return AxiosClient.get("home/digest" + (force ? "?force=true" : ""), {
      responseType: "text",
      useTarget: true,
    });
  } catch (e) {
    console.log(e);
  }
};

export const getInbox = () => {
  try {
    return AxiosClient.get("home/inbox");
  } catch (e) {
    console.log(e);
  }
};

export const getNewData = () => {
  try {
    return AxiosClient.get("home/new-data", { useTarget: true });
  } catch (e) {
    console.log(e);
  }
};

export const getNewsAnchorVideos = () => {
  try {
    return AxiosClient.get("feed/getNewsAnchorVideoVtt", { useTarget: true });
  } catch (e) {
    console.log(e);
  }
};

export const playNewsAnchorVideo = (documentId) => {
  try {
    return AxiosClient.get(
      "feed/playNewsAnchorVideoVtt?document_id=" +
        encodeURIComponent(documentId),
    );
  } catch (e) {
    console.log(e);
  }
};

export const fetchDigestStream = (force = false, signal) => {
  const token = localStorage.getItem("user");

  const params = new URLSearchParams();
  if (force) params.set("force", "true");
  if (apiConfig.target) params.set("target", apiConfig.target);

  const query = params.toString() ? `?${params.toString()}` : "";

  return fetch(`${BASE_URL}home/digest${query}`, {
    headers: { "x-access-token": token },
    signal,
  });
};

export const getLatestGraph = () => {
  try {
    return AxiosClient.get(`home/getLatestHorizonThreats`);
  } catch (e) {
    console.log(e);
  }
};

export const getLatestGraphByTarget = (target) => {
  try {
    return AxiosClient.get(`home/getLatestHorizonThreats?target=${target}`);
  } catch (e) {
    console.log(e);
  }
};
